<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
<div class="unselectable headerTitle headline">{{translation.WheelnewsOrderviewCardTitle}}</div>
<div class="breakLine"></div>
<div id="moduleContent">
<ejs-grid #wheelNewsOrderGrid
          [locale]="locale"
          [dataSource]="dataSource"
          [columns]="options"
          (actionBegin)="actionBegin($event)">
</ejs-grid>
<ng-template #matDialog class="dialog container">
  <h3 class="unselectable">{{translation.WheelNewsOrder + '-' + translation.Information}}</h3>
  <div class="row">
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.OrderNumber}}</mat-label>
      <input name="OrderNumber" matInput type="text" [value]="wheelNewsOrder.Id" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.OrderDate}}</mat-label>
      <input name="OrderDate" matInput type="text" [value]="wheelNewsOrder.OrderDate | date: 'dd.MM.yyyy HH:mm'" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.PickUpDate}}</mat-label>
      <input name="PickUpDate" matInput type="text" [value]="wheelNewsOrder.Sender.PickUpDateText" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.DeliveryOptions}}</mat-label>
      <input name="deliveryOptions" matInput type="text" [(ngModel)]="wheelNewsOrder.DeliveryOptionText" value=" " [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.Client + '-' + translation.ForeignId}}</mat-label>
      <input name="ClientFid" matInput type="text" [value]="wheelNewsOrder.Client.PartnerFid" [readonly]="true">
    </mat-form-field>
  </div>
  <h5 class="unselectable">{{translation.Rims + '-' + translation.Information}}</h5>
  <div class="row">
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.CommissionNumber}}</mat-label>
      <input name="CommissionNumber" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].CommissionNumber" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.RimAmount}}</mat-label>
      <input name="RimAmount" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].RimAmount" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
      <mat-label class="unselectable">{{translation.SparePartNumber}}</mat-label>
      <input name="rimSetSparePartNumber" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].SparePartNumber" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12">
      <mat-label class="unselectable">{{translation.OrderType}}</mat-label>
      <input name="rimSetOrderType" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].OrderTypesString" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12">
      <mat-label class="unselectable">{{translation.OrderDescription}}</mat-label>
      <input name="RimComment" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].Comment" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12">
      <mat-label class="unselectable">{{translation.RepairDescription}}</mat-label>
      <input name="DamageComment" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].DamageComment" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="formField col-xs-12">
      <mat-label class="unselectable">{{translation.RepaintDescription}}</mat-label>
      <input name="RepaintComment" matInput type="text" [(ngModel)]="wheelNewsOrder.RimsetList[0].RepaintComment" [readonly]="true">
    </mat-form-field>
  </div>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <div class="row">
        <h5 class="col-12 unselectable">{{translation.Sender + '-' + translation.Information}}</h5>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.ForeignId}}</mat-label>
          <input name="SenderFid" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.PartnerFid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.PartnerId}}</mat-label>
          <input name="SenderAid" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.PartnerAid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Description}}</mat-label>
          <input name="SenderDescription" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Name" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Street}}</mat-label>
          <input name="SenderStreet" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.AddressLine1" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Addition}}</mat-label>
          <input name="SenderAddition" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.AddressLine2" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Zip}}</mat-label>
          <input name="SenderZip" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Zip" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.City}}</mat-label>
          <input name="SenderCity" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.City" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Contact + '-' + translation.FirstName + '/-' + translation.LastName}}</mat-label>
          <input name="SenderContactName" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Contact" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Contact + '-' + translation.Email}}</mat-label>
          <input name="SenderContactEmail" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Email" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Contact + '-' + translation.Phone}}</mat-label>
          <input name="SenderContactPhone" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Phone" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Comment}}</mat-label>
          <input name="SenderComment" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.Comment" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Sender + '-' + translation.Notification}}</mat-label>
          <input name="SenderNotification" matInput type="text" [(ngModel)]="wheelNewsOrder.Sender.NotificationText" [readonly]="true">
        </mat-form-field>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <div class="row">
        <h5 class="col-12 unselectable">{{translation.Recipient + '-' + translation.Information}}</h5>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.ForeignId}}</mat-label>
          <input name="RecipientFid" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.PartnerFid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.PartnerId}}</mat-label>
          <input name="RecipientAid" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.PartnerAid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Description}}</mat-label>
          <input name="RecipientDescription" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Name" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Street}}</mat-label>
          <input name="RecipientStreet" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.AddressLine1" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Addition}}</mat-label>
          <input name="RecipientAddition" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.AddressLine2" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Zip}}</mat-label>
          <input name="RecipientZip" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Zip" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.City}}</mat-label>
          <input name="RecipientCity" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.City" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Contact + '-' + translation.FirstName + '/-' + translation.LastName}}</mat-label>
          <input name="RecipientContactName" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Contact" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Contact + '-' + translation.Email}}</mat-label>
          <input name="RecipientContactEmail" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Email" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Contact + '-' + translation.Phone}}</mat-label>
          <input name="RecipientContactPhone" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Phone" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Comment}}</mat-label>
          <input name="RecipientComment" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.Comment" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.Recipient + '-' + translation.Notification}}</mat-label>
          <input name="RecipientNotification" matInput type="text" [(ngModel)]="wheelNewsOrder.Recipient.NotificationText" [readonly]="true">
        </mat-form-field>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <div class="row">
        <h5 class="col-12 unselectable">{{translation.FreightPayer + '-' + translation.Information}}</h5>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.FreightPayer + '-' + translation.ForeignId}}</mat-label>
          <input name="freightPayerFid" matInput type="text" [(ngModel)]="wheelNewsOrder.FreightPayerFid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.FreightPayer + '-' + translation.PartnerId}}</mat-label>
          <input name="freightPayerAid" matInput type="text" [(ngModel)]="wheelNewsOrder.FreightPayerAid" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.FreightPayer + '-' + translation.Contact}}</mat-label>
          <input name="freightPayerUser" matInput type="text" [(ngModel)]="wheelNewsOrder.User" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.FreightPayer + '-' + translation.Phone}}</mat-label>
          <input name="freightPayerPhone" matInput type="text" [(ngModel)]="wheelNewsOrder.Phone" [readonly]="true">
        </mat-form-field>
        <mat-form-field class="formField col-12">
          <mat-label class="unselectable">{{translation.FreightPayer + '-' + translation.Email}}</mat-label>
          <input name="freightPayerEmail" matInput type="text" [(ngModel)]="wheelNewsOrder.Email" [readonly]="true">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="customEndRow">
    <mat-dialog-actions class="justify-content-end">
      <button mat-button class="customButtons" (click)="generatePdf(wheelNewsOrder.Id)"><span class="material-icons">print</span> Lieferschein Drucken</button>
      <button mat-button class="customButtons" (click)="cancel()">{{translation.Cancel}}</button>
    </mat-dialog-actions>
  </div>
</ng-template>
</div>
</div>
<app-footer></app-footer>
